<div class="file-container">
  @if (logFiles.length > 0) {
    <div class="card-deck d-flex flex-wrap justify-content-around">
      @for (file of logFiles; track file; let i = $index) {
        <div class="file-log col-4 border border-secondary mb-1 mt-2"
          placement="bottom" [popover]="popTemplate" [popoverContext]="{file:filesAndObjects[i]}" triggers="mouseenter:mouseleave" container="body">
          <div class="image-container d-flex justify-content-center mt-2">
            <img class="card-img-top" [src]="!filesAndObjects[i].src ? filesAndObjects[i].url : filesAndObjects[i].src">
          </div>
          <div class="file-info d-flex justify-content-center my-2">
            <div class="d-flex align-items-center pl-2">
              <div class="file-download bd-highlight">{{file.name}}</div>
            </div>
            <a class="download-icon d-flex align-items-center pr-1" (click)="onDownloadFile(file)">
              <img src="assets/img/download-step-file.svg" alt="" class="download-file">
            </a>
          </div>
          @if (showCheckboxes) {
            <div class="text-center mb-2">
              <input type="checkbox" class="form-check-input editor-access-checkbox"  [(ngModel)]="file.isChecked" (change)="onFileCheckboxChange(file)">
            </div>
          }
        </div>
      }
    </div>
  }

  @if (logFiles.length === 0) {
    <div class="error-message">
      <p>{{'MAIN.SESSIONS.SESSION_FILES.NO_FILE_IS_ADDED' | translate}}</p>
    </div>
  }
</div>

<ng-template #popTemplate let-file="file">
  <div class="file-name"><b>{{ 'MAIN.SESSIONS.SESSION_FILES.FILE_NAME' | translate }}</b> {{ file.name }}</div>
  @if (file.subfiles) {
    <div class="file-name"><b>{{ 'MAIN.SESSIONS.SESSION_FILES.FILE_CONTENTS' | translate }}</b></div>
  }
  @for (f of file.subfiles; track f) {
    <li class="file-name">
      {{ f }}
    </li>
  }
  @if (file.exportPdf) {
    <div class="file-size"><b>{{ 'MAIN.SESSIONS.SESSION_FILES.ESTIMATED_FILE_SIZE' | translate }}</b> {{ 'MAIN.SESSIONS.SESSION_FILES.APPROX_EXPORT_PDF_SIZE' | translate }}</div>
  }
  @if (!file.exportPdf) {
    <div class="file-size"><b>{{ 'MAIN.SESSIONS.SESSION_FILES.FILE_SIZE' | translate }}</b> {{ file.size | fileSize}}</div>
  }
</ng-template>